// extracted by mini-css-extract-plugin
export var brand = "_74-9";
export var compact = "_74-6";
export var extraSmall = "_74-7";
export var icon = "_74-0";
export var large = "_74-4";
export var light = "_74-1";
export var medium = "_74-5";
export var outline = "_74-b";
export var primaryDark = "_74-a";
export var primaryLight = "_74-8";
export var primaryModern = "_74-c";
export var success = "_74-2";
export var successSolid = "_74-3";